import { Injectable, Component } from '@angular/core';

import { CommonModule } from "@angular/common";
// import { modalTemplates } from './modalTemplates';

// import { HubAuthenticationComponent } from './../components/hub-authentication/hub-authentication.component'

@Injectable()
export class LayerService {
    
    public authSection;
    
    public overlaysOpened: number;

    public backdrop = $('<div class="overlay-backdrop"></div>');

    constructor() { 
        this.overlaysOpened = 0;
        this.logWarning();        
    }

    scroll(target: any) {
        $("html, body").animate({ scrollTop: $(target).offset().top }, 1500);
        $(".scroll").removeClass("scroll-active");
        $(target).addClass("scroll-active");
    }

    previous(id: any) {
        $(id).removeClass('out-bottom');
        $(".scroll").removeClass("scroll-active").removeClass("out-top");
        $(id).addClass("scroll-active").addClass("out-top");
    }

    overlay(id: string, section?: string) {
        this.logWarning();         
        this.overlaysOpened++;
        
        this.authSection = ( section ) ? section : 'autentication-after-login';

        this.backdrop.click(() => { this.destroyAllOverlays() });
        $(this.backdrop).appendTo('body');
        $(this.backdrop).fadeIn();
        $(".overlay").removeClass("overlay-active");
        $(id).addClass("active");
        // $('html, body').addClass('block-scroll');
        $('html, body').css('overflow', 'hidden');
        
        if(section){
            this.authSection = section
        }
        else{
            this.authSection = 'autentication-after-login';
        }                

    }

    logWarning(){
        console.warn(`ATENÇÃO: O serviço de overlay foi depreciado em benefício do novo serviço de dialogos 
        (dialogs.service.). Favor não implementar novos recursos usando este serviço.`);
    }

    destroyAllOverlays() {
        $(".overlay").removeClass("active");
        $(".overlay-backdrop").fadeOut("slow", () => {
            $(".overlay-backdrop").remove()
        });
        this.overlaysOpened = 0;
        // $('html, body').removeClass('block-scroll');
        // $('html, body').css('overflow', 'visible');
    }

    destroyOverlay(id: any) {

        this.overlaysOpened--;

        $(id).removeClass("active");
        $(".overlay-backdrop").fadeOut("slow", () => {
            $(".overlay-backdrop").remove()
        });
        $(".backdrop-filter-sticky--js").fadeOut("slow", () => {
            $(".backdrop-filter-sticky--js").remove()
        });
        if( !this.overlaysOpened ) {
            // $('html, body').removeClass('block-scroll');
            $('html, body').css('overflow', 'visible');
        }
    }

    ngOnDestroy() {
        //$('html, body').css('overflow', 'visible');
    }
}